import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const CreditSuccess = () => {
  const navigator = useNavigate();

  const { state } = useLocation();
  const { payment_id, amount } = state;

  setTimeout(() => {
    navigator("/mycredits");
  }, 5000);
  return (
    <>
      <Navbar />
      <div className="row justify-content-center mt-5 pt-5">
        <div className="col-lg-5 mt-5">
          <div className="card shadow-none shadow-0 border-0">
            <div className="card-body text-center">
              <div className="d-flex justify-content-center">
                 <img src="img/success.gif" style={{height:"6rem"}} alt="Success"/>
              </div>
              <h4 className="text-success fw-bolder fs-4 mt-3">
                Payment Successful!
              </h4>

              <p>Payment Id: {payment_id}</p>

              <p>Amount : ₹ {amount}</p>

              <small className="text-center text-muted">
                You will shortly be redirected back to the credits dashboard.
              </small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditSuccess;
